import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { fromEvent } from 'rxjs/observable/fromEvent';

interface TooltipToggle {
  show: boolean;
  event: MouseEvent;
  tooltipInformation: TooltipInformation[];
}

export interface TooltipInformation {
  start: string;
  end: string;
  account: string;
  fund: string;
  added_by: string;
  created: string;
  hold_type: string;
  notes: string;
}

@Injectable()
export class CalendarTooltipService {
  private onMouseenter$: Subscription;
  private onMouseleave$: Subscription;
  private onToggleTooltip$: BehaviorSubject<TooltipToggle> = new BehaviorSubject({show:false, event:null, tooltipInformation: []});
  private reservationsByDate: {[x:string]: TooltipInformation[]} = {};
  tooltipsInformation: TooltipInformation[] = [];

  constructor() { }

  up(data: TooltipInformation[], targets?: string[]) {
    this.tooltipsInformation = data;
    this._setTargetSelectors(targets);
    const elements = document.querySelectorAll('.tooltip-element');
    this._setReservationsByDate(elements)
    this._registerCellMouseEnter(elements);
    this._registerCellMouseLeave(elements);
  }

  down() {
    this.onToggleTooltip$.next({show:false, event:null, tooltipInformation: []});
    this.tooltipsInformation = [];
    this.reservationsByDate = {};
    if (this.onMouseenter$) {
      this.onMouseenter$.unsubscribe();
    }
    if (this.onMouseleave$) {
      this.onMouseleave$.unsubscribe();
    }
    this._removeTargetSelector();
  }

  toogleTooltip$(): Observable<TooltipToggle> {
    return this.onToggleTooltip$.asObservable();
  }

  private _registerCellMouseEnter(elements) {
    this.onMouseenter$ = fromEvent(elements, 'mouseenter')
      .subscribe((event:MouseEvent) => {
        const date = (event.target as HTMLElement).dataset.date;
        const tooltipInformation = this.reservationsByDate[date];
        this.onToggleTooltip$.next({show:true, event, tooltipInformation})
      })
  }

  private _registerCellMouseLeave(elements) {
    this.onMouseleave$ = fromEvent(elements, "mouseleave")
    .subscribe((event:MouseEvent) => {
      this.onToggleTooltip$.next({show:false, event, tooltipInformation:[]})
    });
  }

  private _setReservationsByDate(elements) {
    const cellDates = Array.from(elements).map((element:HTMLElement) => element.dataset.date);
    const _reservations = {};
    cellDates.forEach(date => _reservations[date] = this._getReservationsByDate(date));
    this.reservationsByDate = _reservations;
  }

  private _getReservationsByDate(date): TooltipInformation[] {
    return this.tooltipsInformation
      .filter(reservation =>
        date >= reservation.start &&
        date <= reservation.end
      )
      .sort((a,b) => (a.start > b.start) ? 1 : ((b.start > a.start) ? -1 : 0))
      .slice(0, 3);
  }

  private _setTargetSelectors(selectors: string[] = []) {
    let targetSelectors = ['td.confirmed-reservation'];
    selectors.forEach(selector => targetSelectors.push(`td.${selector}`));
    targetSelectors.forEach(targetSelector => {
      Array.from(document.querySelectorAll(targetSelector))
        .forEach(element => element.classList.add('tooltip-element'));
    });
  }

  private _removeTargetSelector() {
    const elements = document.getElementsByClassName('tooltip-element');
    while(elements.length > 0){
      elements[0].classList.remove('tooltip-element');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/calendar-tooltip.service.ts